import React from 'react'
import { Button, Col, Row } from 'antd'

export default function SaveChangesButton(props) {
  return (
    <Row
      justify='space-around'
      style={{
        padding: 16,
        bottom: 0,
        position: 'fixed',
        zIndex: 1,
        right: 16,
        left: 16 + props.siderWidth,
        backgroundColor: 'rgba(255,255,255,0.4)'
      }}
    >
      <Col span={12}>
        <Button block type='primary' size='middle' onClick={props.onSave}>
          Save Changes
        </Button>
      </Col>
    </Row>
  )
}
